import { render } from "./ShowTitle.vue?vue&type=template&id=b67af3ea&scoped=true"
import script from "./ShowTitle.vue?vue&type=script&lang=js"
export * from "./ShowTitle.vue?vue&type=script&lang=js"

import "./ShowTitle.vue?vue&type=style&index=0&id=b67af3ea&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b67af3ea"]])

export default __exports__